export default __webpack_public_path__ + "static/media/signup_partner_icon.c4212504.png";